import React, { useContext, useState } from 'react'
import styled from '@emotion/styled'
import { array } from 'prop-types'
import { SiteConfigContext } from '../SiteConfigProvider'
import { Link } from '@jelly/ui'

// Styled Components via Emotion
const KebabItem = styled.div`
	border-radius: 50%;
	background: ${({ theme }) => theme.colors.white};
	height: 5px;
	width: 5px;

	.inverse & {
		background: ${({ theme }) => theme.navigation.linkColor};
	}
`
const KebabContainer = styled.div`
	margin: auto 30px auto 0;

	&:hover {
		${KebabItem} {
			background: ${({ theme }) => theme.navigation.linkHoverColor};
		}
	}
`
const KebabWrapper = styled.div`
	cursor: pointer;
	display: flex;
	flex-direction: column;
	height: 20px;
	justify-content: space-between;
	width: auto;
`
const MenuWrapper = styled.div`
	display: ${({ showMenu }) => (showMenu ? 'block' : 'none')};
	margin-right: ${({ hasCommunity }) => (hasCommunity ? '117px' : '65px')};
	padding-top: 10px;
	position: absolute;
	right: 0;
`
const MenuTop = styled.div`
	border-left: 13px solid transparent;
	border-right: 13px solid transparent;
	border-bottom: 15px solid ${({ theme }) => theme.colors.primary};
	margin-left: auto;
	margin-right: 10px;
	right: 0;
	width: 0;
`
const MoreMenu = styled.div`
	background: ${({ theme }) => theme.colors.primary};
	padding: 10px 0;
`
const MenuItem = styled(Link)`
	${({ theme }) => theme.links.white};
	font-family: 'Poppins', sans-serif;
	display: block;
	padding: 5px 24px;
`

/**
 * This is the Kebab Menu
 *
 * @param {Array} props.menuItems :: list of remaining menu items
 */
export function KebabMenu({ menuItems = [] }) {
	const {
		siteConstants: { HAS_COMMUNITY },
	} = useContext(SiteConfigContext)
	const [showMoreMenu, setShowMoreMenu] = useState(false)

	return (
		<KebabContainer onMouseEnter={() => setShowMoreMenu(true)} onMouseLeave={() => setShowMoreMenu(false)}>
			<KebabWrapper>
				<KebabItem />
				<KebabItem />
				<KebabItem />
			</KebabWrapper>
			<MenuWrapper hasCommunity={HAS_COMMUNITY} showMenu={showMoreMenu}>
				<MenuTop />
				<MoreMenu>
					{menuItems &&
						menuItems.map((item, i) => {
							return (
								<MenuItem href={item.slug} key={i}>
									{item.title}
								</MenuItem>
							)
						})}
				</MoreMenu>
			</MenuWrapper>
		</KebabContainer>
	)
}
KebabMenu.propTypes = {
	menuItems: array,
}
